// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2YKQI","col":"styles_col__bHzsF","fulfillmentStatus":"styles_fulfillmentStatus__3W3Lt","emailCol":"styles_emailCol__1U3U2"};